import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { BudgetPickerContentModal } from './BudgetPickerContentModal'
import { BudgetPickerInputField } from './BudgetPickerInputField'
import { ModalPicker, ModalPickerRef } from '../modal-picker'
import { Button } from '../../atoms'
import { ControlledCommons } from '../../atoms/fields/common.interface'
import { cn } from '../../../shadcn/utils'

export interface IControlledBudgetPickerProps extends ControlledCommons {
  isCentered?: boolean
  inputContainerClassName?: string
  innerBudgetPickerModal?: string
  modalClassName?: string
  isFullScreen?: boolean
  revampPicker?: boolean
  isOpen?: boolean
  onClose?: () => void
  onValid?: () => void
  isFromSearchPage: boolean
}

export const BudgetPicker: React.FC<IControlledBudgetPickerProps> = ({
  control,
  rules,
  name,
  isCentered = true,
  inputContainerClassName,
  innerBudgetPickerModal,
  modalClassName,
  isFullScreen = false,
  revampPicker = false,
  isOpen = false,
  onClose,
  onValid,
  isFromSearchPage,
}) => {
  const ref = React.useRef<ModalPickerRef>(null)
  const [isFocused, setIsFocused] = useState<boolean>(false)

  const onFocus = (value: boolean) => () => {
    setIsFocused(value)
  }
  const onCloseModal = () => {
    onClose?.()
    ref.current?.setShowModal(false)
  }

  React.useEffect(() => {
    if (isOpen) {
      ref.current?.setShowModal(true)
    }
  }, [isOpen])

  return (
    <ModalPicker
      revampPicker={revampPicker}
      isFullScreen={isFullScreen}
      dataGtm={revampPicker ? 'budget_picker_new_search' : 'budget_picker'}
      dataMixpanel={{
        name: 'budget_picker',
        data: { newSearch: revampPicker },
      }}
      control={control}
      rules={rules}
      name={name}
      ref={ref}
      mobileTitle={
        <div>
          <FormattedMessage
            id='ui.BudgetPicker.mobileTitle'
            defaultMessage='Budget'
          />
        </div>
      }
      isCentered={isCentered}
      className={inputContainerClassName}
      modalClassName={modalClassName}
      innerModalClassName={innerBudgetPickerModal}
      containerClassName={cn(
        'flex h-full rounded-[5px] border border-grey-500',
        isFocused ? 'border-grey-800' : 'hover:border-grey-600',
      )}
      mobileFooter={
        <div className='flex justify-end border-t border-t-border bg-background px-[5vw] py-[10px]'>
          <Button onClick={onCloseModal} className='px-5 py-[10px]'>
            <FormattedMessage
              id='ui.BudgetPicker.save'
              defaultMessage='Enregistrer'
            />
          </Button>
        </div>
      }
      onOpen={onFocus(true)}
      onClose={onFocus(false)}
      renderContentModal={(field) => (
        <BudgetPickerContentModal
          field={field}
          onCloseModal={onCloseModal}
          onValid={onValid}
        />
      )}
      renderInputField={(field) => (
        <BudgetPickerInputField
          field={field}
          isFocused={isFocused}
          isFromSearchPage={isFromSearchPage}
          revampPicker={revampPicker}
        />
      )}
    />
  )
}
